function getSharedCookieDomain() {
  const hostname = window.location.hostname;
  return hostname === 'elevargestao.com.br' || hostname.endsWith('.elevargestao.com.br')
    ? '; domain=.elevargestao.com.br'
    : '';
}

export const setCookie = (cname: string, cvalue: string | null): void => {
  const sharedDomain = getSharedCookieDomain();
  if (cvalue) {
    localStorage.setItem(cname, cvalue);
    document.cookie = `${cname}=${encodeURIComponent(cvalue)}; path=/; SameSite=Lax${sharedDomain}`;
  } else {
    localStorage.removeItem(cname);
    document.cookie = `${cname}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=Lax${sharedDomain}`;
  }
};

export const getCookie = (cname: string): string => {
  return localStorage.getItem(cname) || '';
};
